module.exports = __webpack_public_path__ + "img/thumbnail_ArcticFox_j_albino.3812812c.png";